import { WALLET_KEY } from "../constants/config";

// Game wallet balance = Deposit + Winning + Bonus
export const playBalanceOf = (wallet) => {
  if (!wallet) return null;

  const deposit = Number(wallet.depositBalance ?? 0);
  const winning = Number(wallet.winningBalance ?? 0);
  const bonus = Number(wallet.bonusBalance ?? 0);

  return deposit + winning + bonus;
};

export const saveWallet = (wallet) => {
  try {
    if (wallet) {
      localStorage.setItem(WALLET_KEY, JSON.stringify(wallet));
    }
  } catch {
    /* storage blocked */
  }
};
